/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyEngine_Models_ApiThemesResult } from '../models/SurveyEngine_Models_ApiThemesResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConfigServiceApiService {

    /**
     * Get the Theme configuration for the specified language
     * StudyId Engine will default to the defaultTheme or en-us language
     * @param theme Theme Name
     * @param language Language culture
     * @returns SurveyEngine_Models_ApiThemesResult OK
     * @throws ApiError
     */
    public static getV1ConfigThemes(
theme?: string,
language?: string,
): CancelablePromise<SurveyEngine_Models_ApiThemesResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/Config/themes',
            query: {
                'theme': theme,
                'language': language,
            },
            errors: {
                400: `Error`,
                404: `Not found`,
            },
        });
    }

}
